//Reset data
export const RESET = "CATEGORY_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "CATEGORY_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CATEGORY_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CATEGORY_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CATEGORY_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "CATEGORY_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CATEGORY_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CATEGORY_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CATEGORY_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CATEGORY_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "CATEGORY_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "CATEGORY_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CATEGORY_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CATEGORY_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CATEGORY_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "CATEGORY_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "CATEGORY_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CATEGORY_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CATEGORY_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CATEGORY_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "CATEGORY_DEL_SET_IS_UPDATE"